export const APP_POPUP_IMAGE_FILE_ERROR_MESSAGE = '이미지 파일만 업로드할 수 있습니다.'
export const APP_POPUP_IMAGE_FILE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,image/png,image/gif,image/jpeg,image/webp'
export const APP_POPUP_IMAGE_PREVIEW_ERROR_MESSAGE = '이미지 미리보기를 만들지 못했습니다.'
export const APP_POPUP_IMAGE_LEAVE_MESSAGE = '선택한 팝업 이미지는 저장 전에 이동하면 사라집니다. 이동하시겠습니까?'
const APP_POPUP_SUPPORTED_TYPES = [1, 2, 4]

export const hasPendingAppPopupImage = (params = {}) => {
    if (typeof File === 'undefined') {
        return false
    }

    return params.image instanceof File
}

// 팝업 이미지 업로드에서 허용하는 파일 형식만 통과시킨다.
export const isAppPopupImageFile = (file) => {
    if (!file) {
        return false
    }

    return (file.type && file.type.startsWith('image/')) || /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name || '')
}

// File 객체를 화면 미리보기용 data URL로 변환한다.
export const readAppPopupImagePreview = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onloadend = () => {
            resolve(reader.result || '')
        }

        reader.onerror = () => {
            reject(reader.error)
        }

        reader.readAsDataURL(file)
    })
}

// 저장 전 필수 입력 조건을 검증하고, 문제가 있으면 운영자에게 보여줄 문구를 반환한다.
export const getAppPopupValidationMessage = (params = {}) => {
    const type = Number(params.type)

    if (!APP_POPUP_SUPPORTED_TYPES.includes(type)) {
        return '지원하지 않는 팝업 구분입니다.'
    }

    if (!params.image) {
        return '이미지를 업로드해주세요.'
    }

    if (type === 2 && !params.meetId) {
        return '상품을 선택해주세요.'
    }

    if (type === 4 && !params.landingUrl) {
        return 'URL을 입력하세요.'
    }

    return ''
}

// 등록/수정 API가 기대하는 multipart payload를 같은 규칙으로 만든다.
export const createAppPopupFormData = (params = {}, { popupId } = {}) => {
    const type = Number(params.type)
    const formData = new FormData()

    if (popupId !== undefined && popupId !== null) {
        formData.append('popupId', popupId)
    }

    formData.append('image', params.image)
    formData.append('deviceType', params.deviceType)
    formData.append('type', params.type)
    formData.append('status', params.status)

    if (type === 2) {
        formData.append('meetId', params.meetId)
    }

    if (type === 4) {
        formData.append('landingUrl', params.landingUrl)
    }

    return formData
}

// type 값 기준으로 애니멀런 상세 상품 선택 섹션을 노출할지 판단한다.
export const shouldShowAppPopupProductPicker = (type) => {
    return Number(type) === 2
}

// 상품 선택 시 기존 폼 값을 보존하면서 meetId만 갱신한다.
export const chooseAppPopupProduct = (params = {}, meetId) => ({
    ...params,
    meetId,
})
